import React from "react";

export function contrastText(hex) {
  if (!hex || hex[0] !== "#") return "#fff";
  const h = hex.replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 160 ? "#1F2937" : "#fff";
}

export default function MoveTypeBadge({ shortCode, color, title, size }) {
  const bg = color || "#5C6675";
  const fg = contrastText(bg);
  const label = (shortCode || "").slice(0, 3).toUpperCase();
  if (size) {
    // Larger rounded-square badge used by the v3 Move Types screen (Figma).
    return (
      <span
        title={title || label}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: size,
          height: size,
          borderRadius: 8,
          background: bg,
          color: fg,
          fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
          fontSize: Math.round(size * 0.34),
          fontWeight: 700,
          letterSpacing: 0.5,
        }}
      >
        {label}
      </span>
    );
  }
  return (
    <span
      title={title || label}
      style={{
        display: "inline-block",
        minWidth: 36,
        padding: "2px 6px",
        borderRadius: 4,
        background: bg,
        color: fg,
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0.5,
        textAlign: "center",
        lineHeight: "18px",
      }}
    >
      {label}
    </span>
  );
}
